export default {
    months: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ],
    monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays: 'Søndag_Mandag_Tirsdag_Onsdag_Torsdag_Fredag_Lørdag'.split('_'),
    weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
    week: {
        dow: 1,
        doy: 4
    },
    relativeTime: {
        future: 'om %s',
        past: 'for %s siden',
        s: 'noen sekund',
        m: 'et minutt',
        mm: '%d minutt',
        h: 'en time',
        hh: '%d timer',
        d: 'en dag',
        dd: '%d dager',
        M: 'en måned',
        MM: '%d måneder',
        y: 'et år',
        yy: '%d år'
    }
};



/** WEBPACK FOOTER **
 ** ../src/widgets/i18/moment/locale.no.js
 **/